import BehavioralList from './behavioral-list';

export default BehavioralList;
